import $ from 'jquery';

var Tooltip = {
    _element: null,

    init: function() {
        this.setEvents();
    },

    setEvents: function() {
        $(document).on('mouseenter', '.tooltip', this.mouseEnter);
        $(document).on('mouseleave', '.tooltip', this.mouseLeave);
        $(document).on('click',      '.feature-tooltip a.skip', this.skipFeatureTip);
    },

    mouseEnter: function(e) {
        e.preventDefault();

        $(this).data('mouseenter', true);

        setTimeout(() => {
            if (!$(this).data('mouseenter')) {
                return;
            }

            if (!$(this).data('title')) {
                return;
            }

            // for touch screen tooltip delay
            if ($(this).is(':hidden')) {
                return;
            }

            var direction   = $(this).data('position') || 'up';
            var theme       = $(this).data('theme');
            var tooltip     = $('<div>').addClass('tooltip-ui').text($(this).data('title'));
            var tablet_only = $(this).data('tablet');

            if (theme) {
                tooltip.addClass('tooltip-ui-' + theme);
            }

            if (direction !== 'up') {
                tooltip.addClass('tooltip-ui-' + direction);
            }

            if (tablet_only) {
                tooltip.addClass('tablet-only');
            }

            tooltip.appendTo($(document.body));

            var offset_x = 0;
            var offset_y = 0;
            var offset = $(this).data('offset');

            if (offset) {
                offset_x = parseInt(offset.split(',')[0].trim(), 10);
                offset_y = parseInt(offset.split(',')[1].trim(), 10);
            }

            if (direction === 'up') {
                tooltip.css({
                    top:  $(this).offset().top - tooltip.height() + offset_y,
                    left: $(this).offset().left + $(this).outerWidth() / 2 - tooltip.outerWidth() / 2 + offset_x
                });
            } else if (direction === 'down') {
                tooltip.css({
                    top:  $(this).offset().top + $(this).outerHeight() + offset_y,
                    left: $(this).offset().left + $(this).outerWidth() / 2 - tooltip.outerWidth() / 2 + offset_x
                });
            } else if (direction === 'right') {
                tooltip.css({
                    top:  $(this).offset().top + ($(this).outerHeight() - tooltip.outerHeight()) / 2 + offset_y,
                    left: $(this).offset().left + $(this).outerWidth() + offset_x
                });
            }

            $(this).data('tooltip_ui', tooltip);
        }, 200);
    },

    mouseLeave: function(e) {
        $(this).data('mouseenter', false);
        $('.tooltip-ui').remove();
    },

    removeAll: function() {
        $('.tooltip-ui').remove();
    },

    positionFeatureTip: function(element, target, offset) {
        var direction = element.data('direction');
        var left = 0;
        var top  = 0;

        switch (direction) {
            case 'right':
                left = $(target).get(0).getBoundingClientRect().left - element.outerWidth(false);
                top  = $(target).get(0).getBoundingClientRect().top - (element.outerHeight(false) / 2 - $(target).outerHeight(false) / 2);

                break;
            case 'top':
                left = $(target).get(0).getBoundingClientRect().left - (element.outerWidth(false) / 2 - $(target).outerWidth(false) / 2);
                top  = $(target).get(0).getBoundingClientRect().top + $(target).outerHeight(false);

                break;
            case 'top_left':
                left = $(target).get(0).getBoundingClientRect().left;
                top  = $(target).get(0).getBoundingClientRect().top + $(target).outerHeight(false);

                break;
            case 'left':
                left = $(target).get(0).getBoundingClientRect().left + $(target).outerWidth(false);
                top  = $(target).get(0).getBoundingClientRect().top - (element.outerHeight(false) / 2 - $(target).outerHeight(false) / 2);

                break;
        }

        element.css({
            left : left + offset[0],
            top  : top + offset[1]
        });
    },

    removeFeatureTip: function() {
        $('.feature-tooltip').remove();
        $(window).off('resize.featureTip');
    },

    skipFeatureTip: function() {
        $('.feature-tooltip').remove();
        $(window).off('resize.featureTip');

        $('.menu-notification .fa-bells').addClass('animated swing infinite');
        setTimeout(function() {
            $('.menu-notification .fa-bells').removeClass('animated swing infinite');
        }, 3000);
    },

    addFeatureTip: function(target, direction, title, description, next_handler, ok_handler, offset) {
        $('.feature-tooltip').remove();

        if (!$(target).length) {
            return;
        }

        $(window).scrollTop(0);

        offset = offset || [0, 0];

        var html = '<div class="feature-tooltip" data-direction="' + direction + '">' +
                        (title ? '<div class="title">' + title + '</div>' : '') +
                        '<div class="description">' + description + '</div>' +
                        '<div class="dot"></div>' +
                        //'<a class="skip" href="#"><i class="fa fa-times"></i></a>' +
                        (next_handler ? '<a class="next" href="#">Next</a>' : '') +
                        (ok_handler   ? '<a class="ok" href="#">Got it</a>' : '') +
                    '</div>';

        var element = $(html).appendTo($(document.body));
        this.positionFeatureTip(element, target, offset);

        if (next_handler) {
            element.find('a.next').on('click', function(e) {
                e.preventDefault();
                next_handler();
            });
        }

        if (ok_handler) {
            element.find('a.ok').on('click', function(e) {
                e.preventDefault();
                ok_handler();
            });
        }

        $(window).on('resize.featureTip', function() {
            this.positionFeatureTip(element, target, offset);
        }.bind(this));

        // wait for the tooltip to display from animation
        setTimeout(function() {
            $(document).one('click', this.skipFeatureTip);
        }.bind(this), 200);
    }
};

export default Tooltip;